<template>
  <div>
    <div class="title">询问管理</div>
    <div class="container">
      <div class="headermain">
        <!-- <el-select
          v-model="menuid"
          placeholder="请选择"
          style="margin-right:10px;width:150px"
          :clearable="true"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>-->
        <el-input v-model="keyword" placeholder="请输入案件名称" style="width:200px;margin-right:10px"></el-input>

        <el-date-picker v-model="moment" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="timeChange" :picker-options="startPickerOptions" style="margin-right:10px;width:380px" class="mr20"></el-date-picker>
        <el-button type="primary" @click="query" v-if="searchShow">
          <i class="el-icon-search"></i>
          查询
        </el-button>
        <el-button type="primary" @click="opendetail" v-if="createblShow">
          <i class="el-icon-folder-add"></i>
          创建笔录
        </el-button>
      </div>
      <div class="tablemain">
        <el-table :data="tableData" style="width: 100%" border>
          <el-table-column prop="recordPO.caseName" label="案件名称" min-width="150"></el-table-column>
          <el-table-column prop="recordPO.respondentName" label="被询问人"></el-table-column>
          <el-table-column prop="recordPO.respondentName" label="询问人">
            <template slot-scope="scop">{{scop.row.mainInquirer?scop.row.mainInquirer.nickname:''}} {{scop.row.auxiliaryInquirer?scop.row.auxiliaryInquirer.nickname:''}}</template>
          </el-table-column>
          <el-table-column prop="recordPO.inquiryBegin" label="笔录开始时间"></el-table-column>
          <el-table-column prop="recordPO.respondentName" label="时长（分）" width="100px">
            <template slot-scope="scop">{{scop.row.recordPO.inquiryEnd?((new Date(scop.row.recordPO.inquiryEnd).getTime()- new Date(scop.row.recordPO.inquiryBegin).getTime())/1000/60).toFixed(1):"-" }}</template>
          </el-table-column>

          <el-table-column prop="recordPO.status" label="状态">
            <template slot-scope="scop">
              <div v-if="scop.row.recordPO.status===1" class="unqualified">未完成</div>
              <div v-if="scop.row.recordPO.status===2" class="qualified">已完成</div>
            </template>
          </el-table-column>
          <el-table-column prop="recordPO.visibility" label="是否所有人可见" v-if="switchShow">
            <template slot-scope="scop">
              <el-switch style="display: block" v-model="scop.row.recordPO.visibility" active-color="#13ce66" inactive-color="#ff4949" active-text="是" :active-value="1" :inactive-value="0" inactive-text="否" @change="(value)=>changeVisible(value,scop.row.recordPO.id)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="操作" min-width="120">
            <template slot-scope="scope">
              <div>
                <span style="margin-right:10px;cursor:pointer"  @click="edit(scope.row)" v-if="!scope.row.recordPO.signUrl&&editbl">修改</span>
                <span style="margin-right:10px;cursor:pointer"  @click="edits(scope.row)" v-if="scope.row.recordPO.signUrl&&viewbl">查看</span>
                <span style="margin-right:10px;cursor:pointer"  @click="deletebtn(scope.row)" v-if="deletebl">删除</span>
                <span style="margin-right:10px;cursor:pointer"  @click="downloadbtn(scope.row)" v-if="downloadbl">下载</span>
                <span style="margin-right:10px;cursor:pointer"  @click="previewbtn(scope.row)" v-if="reviewbl">预览</span>
                <span style="margin-right:10px;cursor:pointer"  @click="lookbtn(scope.row)" v-if="reviewvideo">查看视频</span>
                <span style="margin-right:10px;cursor:pointer"  @click="copybtn(scope.row)" v-if="copybl">复制</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="paginationmain">
          <el-pagination background layout="prev, pager, next" :total="totalpage" @current-change="operatesizechange" :current-page.sync="pageNum" hide-on-single-page></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="addVisible" title="创建笔录" width="400px" :show-close="false" top="10vh">
      <div slot="title">
        <p>创建笔录</p>
        <i class="el-icon-error" @click="addVisible = false" style="cursor:pointer"></i>
      </div>
      <div class="linetitle" style="margin-top:0px">
        <span class="redbi">*</span>案由名称：
      </div>
      <el-select placeholder="请选择案由名称" :disabled="caseDisabled" @change="changeRole" style="width:100%" v-model="caseid">
        <el-option v-for="item in caseData" :key="item.id" :label="item.typeName" :value="item.id" :name="item.typeName"></el-option>
      </el-select>
      <div class="linetitle">
        <span class="redbi">*</span>询问场景：
      </div>
      <el-select placeholder="请选择询问场景" @change="changeScene" style="width:100%" v-model="inquiryScene">
        <el-option v-for="item in sceneData" :key="item.sceneName" :label="item.sceneName" :value="item.sceneName"></el-option>
      </el-select>
      <div class="linetitle">
        <span class="redbi">*</span>主询问人：
      </div>
      <el-input  style="width:100%" v-model="mainInquirer" readonly="true">
      </el-input>
      <!-- <el-select placeholder="请输入辅询问人" @change="assismainpeople" style="width:100%" v-model="mainInquirer">
        <el-option v-for="item in userdata" :key="item.user.id" :label="item.user.nickname" :value="item.user.id"></el-option>
      </el-select>       -->
      <div class="linetitle">
        <span class="redbi">*</span>辅询问人：
      </div>
      <el-select placeholder="请输入辅询问人" @change="assistaskpeople" style="width:100%" v-model="assistInquirer">
        <el-option v-for="item in userdata" :key="item.user.id" :label="item.user.nickname" :value="item.user.id"></el-option>
      </el-select>
      <div class="linetitle">
        <span class="redbi">*</span>询问地点：
      </div>
      <el-input v-model="inquiryPlace" placeholder="请输入询问地点" style="width:100%"></el-input>
      <div class="linetitle">
        <span class="redbi">*</span>案发单位：
      </div>
      <el-input v-model="happenPlace" placeholder="请输入案发单位" style="width:100%"></el-input>
      <div slot="footer" class="dialogBtn">
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="lookvisible" title="查看视频" width="400px" :show-close="false" @close="closed" destroy-on-close top="10vh">
      <div slot="title">
        <p>查看视频</p>
        <i class="el-icon-error" @click="lookvisible = false" style="cursor:pointer"></i>
      </div>
      <div>
        <video :src="videourl" style="width:100%" autoplay controls></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getrecordlist,
  getcaselist,
  getuserlist,
  deleterecord,
  addrecord,
  previewpdf,
  setVisible
} from "../axios/api.js";
export default {
  data () {
    return {
      tableData: [],
      caseData: [],
      // caseObj: {},
      caseDisabled: false,
      caseName: "",
      caseid: "",
      inquiryPlace: "",
      mainInquirer: localStorage.getItem('username'),
      assistInquirer: "",
      happenPlace: "",
      respondentWorkUnit: "",
      pageNum: 1,
      inquiryScene: "",
      lookvisible: false,
      keyword: "",
      videourl: "",
      userdata: [],
      totalpage: 0,
      sceneData: [
        {
          id: 1,
          sceneName: "询问室"
        },
        {
          id: 2,
          sceneName: "外出"
        },
        {
          id: 3,
          sceneName: "远程视频"
        }
      ],
      addVisible: false,
      moment: "",
      copy: false,
      startPickerOptions: {
        disabledDate: time => {
          //小于最小时间或者大于最大时间都不可选
          return time.getTime() > new Date();
        },
        shortcuts: [
          {
            text: "今天",
            onClick (picker) {
              const end = new Date();
              const start = new Date().toLocaleDateString();
              // start.setTime(new Date());
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "昨天",
            onClick (picker) {
              const end = new Date(new Date().toLocaleDateString());
              const start = new Date(new Date().toLocaleDateString());
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              end.setTime(end.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三天",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      searchShow:false,
      createblShow:false,
      editbl:false,
      viewbl:false,
      deletebl:false,
      reviewbl:false,
      reviewvideo:false,
      copybl:false,
      downloadbl:false,
      switchShow:false,
      mainpeopleId:null
    };
  },
  methods: {
    btnShow(){
      const arr = localStorage.getItem("permissionList")
      var newArr=JSON.parse(arr.replace(/\n/g,"\\n").replace(/\r/g,"\\r")).filter(i=>i.type==="B");
      newArr.forEach(j=>{
        if(j.id=='11'){
          this.searchShow=true
        }if (j.id=='12') {
          this.createblShow=true
        }if (j.id=='13') {
          this.viewbl=true
        }if (j.id=='14') {
          this.deletebl=true
        }if (j.id=='15') {
          this.downloadbl=true
        }if (j.id=='16') {
          this.reviewbl=true
        }if (j.id=='17') {
          this.reviewvideo=true
        }if (j.id=='18') {
          this.copybl=true
        }if (j.id=='19') {
          this.switchShow=true
        }if (j.id=='20') {
          this.editbl=true
        }
      })

      console.log(newArr);
    },
    opendetail () {
      this.caseid = ''
      this.addVisible = true;
      this.copy = false
      this.caseDisabled = false
      // window.location.href = "/askdetail";
    },
    //查询
    query () {
      this.pageNum = 1;
      this.getlist();
    },

    //关闭弹窗
    closed () {
      // console.log(111);
      this.videourl = null;
    },

    // 选择案由
    changeRole (val) {
      // console.log(b);
      // console.log(val, this.caseObj);
      // this.caseName = val.typeName;
      // this.caseid = val;
      this.caseName = this.caseData.filter(el => el.id === val)[0].typeName
      // console.log('this.caseid,this.caseName :>> ', this.caseid, this.caseName);
    },

    timeChange (value) {
      if (value) {
        this.start = this.$moment(value[0]).format("yyyy-MM-DD 00:00:00");
        this.stop = this.$moment(value[1]).format("yyyy-MM-DD 23:59:59");
      } else {
        this.start = null;
        this.stop = null;
      }
      this.pageNum = 1;
      this.pageSize = 10;
      this.getlist();
    },

    //修改询问笔录
    edit (e) {
      // console.log(e);
      localStorage.setItem("caseid", e.recordPO.id);
      this.copy = false
      this.$router.push({
        path: '/askdetail',
        query: {
          copy: this.copy
        }
      })
    },

    //修改询问笔录
    edits (e) {
      // console.log(e);
      this.copy = false
      localStorage.setItem("caseid", e.recordPO.id);
      // window.location.href = "/askdetails";
      this.$router.push('/askdetails')
    },

    //下载word
    downloadbtn (e) {
      window.location.href =
        "https://videoapi.terabits.cn/record/" + e.recordPO.id + "/export/word";
      // window.open(
      //   "https://videoapi.terabits.cn/record/" + e.recordPO.id + "/export/word"
      // );
    },

    //预览PDF
    previewbtn (e) {
      // console.log(e);
      previewpdf([e.recordPO.id]).then(res => {
        if (res && res.code === 200) {
          // console.log(11);
          window.open("https://videoapi.terabits.cn" + res.data);
        }
      });
    },
    //查看视频
    lookbtn (e) {
      // console.log(e);
      // console.log(e.recordPO);
      // console.log(e.recordPO.videoUrl);
      if (!e.recordPO.videoUrl) {
        this.$message.error("暂无视频");
      } else {
        this.videourl = "https://videoapi.terabits.cn" + e.recordPO.videoUrl;
        this.lookvisible = true;
      }

      // console.log(this.videourl);
    },

    //删除询问管理
    deletebtn (e) {
      // console.log(e);
      this.$confirm("您确定要删除该案件吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        callback: action => {
          if (action === "confirm") {
            deleterecord([e.recordPO.id]).then(res => {
              if (res && res.code === 200) {
                this.$message({
                  message: "删除案件成功",
                  type: "success"
                });
                this.getlist();
              }
            });
          }
        }
      });
    },

    // 选择询问场景
    changeScene (val) {
      // console.log(val);
      this.inquiryScene = val;
    },


    // 选择辅询问人
    assistaskpeople (val) {
      // console.log(val);
      this.assistInquirer = val;
    },

    //确认创建笔录
    submitForm () {
      if (!this.caseid) {
        this.$message.error("请选择案由");
      } else if (!this.inquiryScene) {
        this.$message.error("请选择询问场景");
      } else if (!this.assistInquirer) {
        this.$message.error("请选择辅询问人");
      } else if (!this.inquiryPlace) {
        this.$message.error("请输入询问地点");
      } else if (!this.happenPlace) {
        this.$message.error("请输入案发地点");
      } else {
        const params = {
          recordPO: {
            auxiliaryInquirerId: this.assistInquirer,
            caseName: this.happenPlace + this.caseName + "案",
            caseTypeId: this.caseid,
            createTime: "",
            deptId: 0,
            happenPlace: this.happenPlace,
            id: "",
            inquiryBegin: this.$moment(new Date()).format("yyyy-MM-DD HH:mm:ss"),
            inquiryEnd: "",
            inquiryPlace: this.inquiryPlace,
            inquiryScene: this.inquiryScene,
            mainInquirerId: this.mainpeopleId,
            respondTimes: 0,
            respondentAddress: "",
            respondentAge: 0,
            respondentCertNo: "",
            respondentCertType: "",
            respondentEdu: "",
            respondentGender: "",
            respondentName: "",
            respondentNation: "",
            respondentOccupation: "",
            respondentOrigin: "",
            respondentPhone: "",
            respondentType: "",
            respondentWorkUnit: "",
            updateTime: "",
            videoUrl: ""
          }
        };
        addrecord(params).then(res => {
          if (res && res.code === 200) {
            localStorage.setItem("caseid", res.data.recordPO.id);
            this.$message.success("创建笔录成功");
            this.addVisible = false;
            // window.location.href = "/askdetail";
            this.$router.push({
              path: '/askdetail',
              query: {
                copy: this.copy
              }
            })
          }
        });
      }
    },

    //分页
    operatesizechange (e) {
      // console.log(e);
      this.pageNum = e;
      this.getlist();
    },

    getlist () {
      const params = {
        pageNum: this.pageNum,
        pageSize: 10,
        begin: this.start,
        end: this.stop,
        keyword: this.keyword
      };
      getrecordlist(params).then(res => {
        // console.log(res.rows);
        if (res && res.code === 200) {
          // console.log(111);
          this.tableData = res.rows;
          this.totalpage = res.total;
          // console.log(this.tableData);
        }
      });
    },
    getcaselist () {
      this.$emit("getShopCode", true);
      getcaselist().then(res => {
        if (res && res.code === 200) {
          this.caseData = res.rows;
        }
      });
    },
    //获取用户列表
    getuser () {
      const params = {
        pageNum: 1,
        pageSize: 100
      };
      getuserlist(params).then(res => {
        // // console.log(res.rows);
        this.userdata = res.rows;
        this.mainpeopleId =res.rows.filter(i=>i.user.nickname===localStorage.getItem('username'))[0].user.id
        console.log(this.mainpeopleId);
        // this.tableData = res.rows;
      });
    },
    // 复制按钮
    copybtn (val) {
      // console.log('val :>> ', val);
      localStorage.setItem('copyquestions', this.$Base64.encode(JSON.stringify(val.questions)))
      this.caseid = val.recordPO.caseTypeId
      this.caseName = this.caseData.filter(el => el.id === val.recordPO.caseTypeId)[0].typeName
      this.caseDisabled = true
      this.addVisible = true
      this.copy = true
    },
    // 修改是否可见
    changeVisible (value, id) {
      // console.log('value,scope', value, scope)
      setVisible(id, value).then(res => {
        // console.log('res', res)
        if (res) {
          this.$message.success('修改成功')
        }
        this.getlist();
      }).catch(err => {
        console.log('err', err)
        this.getlist();
      })
    }
  },
  created () {
    this.btnShow()
    this.getlist();
    this.getuser();
    this.getcaselist();
  }
};
</script>

<style scoped>
.redbi {
  color: red;
  font-size: 14px;
  margin-right: 5px;
}

.linetitle {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  margin-top: 10px;
}

.headermain {
  padding: 24px;
  padding-left: 0px;
}

.title {
  text-align: left;
  margin-top: 20px;
  font-size: 18px;
  font-weight: bold;
}

.container {
  /* padding: 24px; */
  background: #ffffff;
  border: 1px solid #eaeaea;
  box-shadow: 0px 0px 8px 0px rgba(202, 202, 202, 0.3);
  text-align: left;
  border-radius: 3px;
  margin-top: 24px;
}
</style>
